// ============================================================
// ⚛️ QuantumPass.jsx — Wrapper public vers le générateur existant
// Version : 2.6 SAFE-ADD
// ============================================================

import React from "react";
import TokenGeneratorDashboardPage from "./TokenGeneratorDashboardPage";

export default function QuantumPass() {
  return (
    <div className="min-h-screen bg-black text-white p-6">
      <h1 className="text-3xl font-bold mb-4">🔐 Quantum Pass</h1>
      <p className="text-gray-300 mb-6">
        Générateur de mots de passe entropiques — version publique.
      </p>
      <TokenGeneratorDashboardPage />
    </div>
  );
}
